<template>
  <div>
    <div
      id="page-container"
      class="enable-page-overlay side-scroll main-content-boxed"
    >
      <header-component></header-component>
      <sidebar-component></sidebar-component>
      <main id="main-container">
        <div class="bg-body-light border-top border-bottom">
          <div class="content content-full py-1">
            <div
              class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center"
            >
              <h1
                class="flex-sm-fill font-size-sm text-uppercase font-w700 mt-2 mb-0 mb-sm-2"
              >
                <i class="fa fa-angle-right fa-fw text-primary"></i> Welcome Hi
                {{ this.username }}
              </h1>
            </div>
          </div>
        </div>
        <div class="content">
          <navigator></navigator>
          <forms-list></forms-list>
        </div>
      </main>
      <!-- <nav
      class="navbar navbar-light p-4 mt-4 w-100 bottom"
      style=" background-color: #ffa400 !important;font-size:16px"
    >
      <div class="container">
        <a href="/" class="navbar-brand text-dual"
          ><span class="font-w300 text-white">Copyright© 2020</span>
          <span class="font-w300 text-white">ARX</span></a
        >
      </div>
    </nav> -->
    </div>
    <!-- <footer class="footer footer-light">
    <div class="footer-copyright text-center py-3">
      <a href="/" class="navbar-brand text-dual">
        Copyright© 2020 ARX
      </a>
    </div>      
  </footer>   -->
  </div>
</template>

<script>
import HeaderComponent from "../components/layout/Header";
import SidebarComponent from "../components/layout/Sidebar";
import FormsList from "../components/FormsList";
import Navigator from "../components/layout/Navigator";
import safeLocalStorage from "../utils/localstorage";

export default {
  name: "Dashboard",
  components: { Navigator, FormsList, SidebarComponent, HeaderComponent },
  methods: {
    editForm: function(id) {
      if (id === 1) {
        window.location.href = "/editor/1";
      }
      if (id === 2) {
        window.location.href = "/editor/2";
      }
    },
    preview: function(id) {
      if (id === 1) {
        window.location.href = "/preview/1";
      }
      if (id === 2) {
        window.location.href = "/preview/2";
      }
    }
  },
  data: function() {
    return {
      username: "User"
    };
  },
  mounted() {
    if (safeLocalStorage.getItem("user")) {
      try {
        this.username = JSON.parse(safeLocalStorage.getItem("user")).name;
      } catch (e) {
        this.username = "User";
      }
    }
  }
};
</script>

<style scoped>
footer {
  position: bottom;
  height: 100px;
  bottom: 0;
  width: 100%;
}
</style>
